import React, { useContext } from "react";
import ModelContext from "../ModelContext";
import FooterCustomLine from "./FooterCustomLine";

export const Footer = (props) => {
    const modelCtx = useContext(ModelContext);
    let isCustomLine = (modelCtx.modelsData[0].brandName === "Custom Line");

    return (
        <div>
            <div className="row">
                <div className="col-12">
                    <div className="box">
                        <br /><br /><br />
                    </div>
                </div>
            </div>
            <div className="row">
                {isCustomLine && <FooterCustomLine />}
            </div>
        </div>
    );
};

export default Footer;
